/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-10-26 09:40:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-25 17:02:38
 */
import axios from 'axios';
import { ServerPath } from '@/config/serverPath';

// 登录验证
export async function login(loginInfo) {
    var resp = await axios.post(`${ServerPath}/api/login_check/index.html`, loginInfo, {
        withCredentials: true // 可以携带cookie
    });

    // 保存token
    var token = resp.headers.authorization;
    if (token) {
        localStorage.setItem('token', token);
        return resp.data;
    }
    return resp;
}

/**
 * @name: 商品加入购物车
 * @msg:  无
 * @param {*} add_form{id,num,attr}
 * @return {*}
 */
export async function add_cart(id, num, attr) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'POST',
        url: `${ServerPath}/api/api/add_cart.html`,
        headers: {
            authorization: `bearer ${token}`
        },
        data: {
            id: id,
            num: num,
            attr: attr
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 删除购物车商品
 * @msg:  无
 * @param {id} 订单中商品ID
 * @return {*}
 */
 export async function delete_cart(id) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'POST',
        url: `${ServerPath}/api/api/delete_cart.html`,
        headers: {
            authorization: `bearer ${token}`
        },
        data: {
            id: id,
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}


/**
 * @name: 购物车结算
 * @msg:  无
 * @param {goods_info, order_addr} 购物车商品信息，订单地址
 * @return {*}
 */
 export async function settle_accounts(goods_info, order_addr) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'POST',
        url: `${ServerPath}/api/api/settle_accounts.html`,
        headers: {
            authorization: `bearer ${token}`
        },
        data: {
            goods_list: goods_info,
            order_addr: order_addr
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 修改购物车商品数量
 * @msg:  无
 * @param {goods_info, order_addr} 购物车商品信息，订单地址
 * @return {*}
 */
 export async function changeGoodsNum(id, num, order_goods_id) {
    var token = localStorage.getItem('token');
    var resp = null;
    await axios({
        method: 'POST',
        url: `${ServerPath}/api/api/change_goods_num.html`,
        headers: {
            authorization: `bearer ${token}`
        },
        data: {
            id: id,
            num: num,
            order_goods_id: order_goods_id
        }
    }).then(res => {
        resp = res.data.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}